import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "x", "y", "rx", "ry", "width", "height", "fill", "stroke", "stroke-width", "shape-rendering"]

import type { CSSProperties } from 'vue'
import { inject, toRef, useAttrs } from 'vue'
import type { MiniMapNodeEmits, MiniMapNodeProps } from '@vue-flow/minimap'
import { Slots } from '@vue-flow/minimap'


export default /*#__PURE__*/_defineComponent({
  __name: 'MiniMapNode',
  props: {
    id: {},
    type: {},
    selected: { type: Boolean },
    dragging: { type: Boolean },
    position: {},
    dimensions: {},
    borderRadius: {},
    color: {},
    shapeRendering: {},
    strokeColor: {},
    strokeWidth: {}
  },
  emits: ["click", "dblclick", "mouseenter", "mousemove", "mouseleave"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const miniMapSlots = inject(Slots)!

const attrs = useAttrs()

const style = toRef(() => (attrs.style ?? {}) as CSSProperties)

function onClick(event: MouseEvent) {
	emits('click', event)
}

function onDblclick(event: MouseEvent) {
	emits('dblclick', event)
}

function onMouseEnter(event: MouseEvent) {
	emits('mouseenter', event)
}

function onMouseMove(event: MouseEvent) {
	emits('mousemove', event)
}

function onMouseLeave(event: MouseEvent) {
	emits('mouseleave', event)
}

return (_ctx: any,_cache: any) => {
  return (_unref(miniMapSlots)[`node-${props.type}`])
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(miniMapSlots)[`node-${props.type}`]), _normalizeProps(_mergeProps({ key: 0 }, props)), null, 16))
    : (_openBlock(), _createElementBlock("rect", {
        key: 1,
        id: _ctx.id,
        class: _normalizeClass(["vue-flow__minimap-node", { selected: _ctx.selected, dragging: _ctx.dragging }]),
        x: _ctx.position.x,
        y: _ctx.position.y,
        rx: _ctx.borderRadius,
        ry: _ctx.borderRadius,
        width: _ctx.dimensions.width,
        height: _ctx.dimensions.height,
        fill: _ctx.color || (style.value.background as string) || style.value.backgroundColor,
        stroke: _ctx.strokeColor,
        "stroke-width": _ctx.strokeWidth,
        "shape-rendering": _ctx.shapeRendering,
        onClick: onClick,
        onDblclick: onDblclick,
        onMouseenter: onMouseEnter,
        onMousemove: onMouseMove,
        onMouseleave: onMouseLeave
      }, null, 42, _hoisted_1))
}
}

})